import React, {Fragment} from 'react';
import {Icons, Popup} from 'components';
import {useNamedSelector, openPopup} from 'helpers';
import {set} from 'store/settings';

export function SidebarPreferences() {
  return (
    <Icons.Sort title="Sort by" onClick={openPopup(SortSettings)} />
  );
}

function SortSettings() {
  const { sort } = useNamedSelector('diary.options');
  return (
    <Fragment>
      <b>Sort by</b>
      <Popup.Menu>
        <Popup.Menu.Radio onClick={() => set({ module: 'diary', key: 'sort', value: 'newest' })} checked={sort == 'newest'}>Newest first</Popup.Menu.Radio>
        <Popup.Menu.Radio onClick={() => set({ module: 'diary', key: 'sort', value: 'oldest' })} checked={sort == 'oldest'}>Oldest first</Popup.Menu.Radio>
      </Popup.Menu>
    </Fragment>
  );
}
